export default __webpack_public_path__ + "static/havant-2-a3e4c0d97fb3ebbfa8bfc8a17f088fe1.jpg";